import { render, staticRenderFns } from "./PersonalSecurityTable.vue?vue&type=template&id=126de7b4&scoped=true"
import script from "./PersonalSecurityTable.vue?vue&type=script&lang=js"
export * from "./PersonalSecurityTable.vue?vue&type=script&lang=js"
import style0 from "./PersonalSecurityTable.vue?vue&type=style&index=0&id=126de7b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126de7b4",
  null
  
)

export default component.exports